const CommonTitleDescription = ({ Icon, title, description, handleClose }) => {
  return (
    <div className="flex items-start justify-between w-full">
      <div className="flex flex-col gap-0.5">
        <div className="flex gap-1 items-center">
          {Icon}
          <h4 className="text-[0.815rem] font-semibold text-gray-800 dark:text-gray-100">
            {title}
          </h4>
        </div>
        <p className="text-gray-600 dark:text-gray-400 text-[0.815rem] font-normal font-inter">
          {description}
        </p>
      </div>
    </div>
  );
};

export default CommonTitleDescription;
